/**
 * Fetch form skeleton for a specific category
 * Returns the registrationFromSkeleton, editFormSkeleton, or correctionFormSkeleton
 */
import { getCategories } from '../../../data/repositories/businessRepository.js';

export const fetchFormSkeleton = async (categoryId, formType = 'registration') => {
  try {
    // Fetch all categories with form skeletons
    const response = await getCategories();
    
    let categories = [];
    if (Array.isArray(response)) {
      categories = response;
    } else if (response.data && Array.isArray(response.data)) {
      categories = response.data;
    }

    // Find the category by ID (search in nested structure)
    const findCategory = (cats, id) => {
      for (const cat of cats) {
        if (cat.id === id) return cat;
        if (cat.childrens && cat.childrens.length > 0) {
          const found = findCategory(cat.childrens, id);
          if (found) return found;
        }
      }
      return null;
    };

    const category = findCategory(categories, categoryId);
    
    if (!category) {
      throw new Error('Category not found');
    }

    // Return the appropriate form skeleton
    if (formType === 'registration') {
      return category.registrationFromSkeleton || null;
    } else if (formType === 'edit') {
      return category.editFormSkeleton || null;
    } else if (formType === 'correction') {
      return category.correctionFormSkeleton || null;
    }

    return null;
  } catch (error) {
    console.error('Error fetching form skeleton:', error);
    throw error;
  }
};

/**
 * Get form skeleton from main category (Business, Sampada, Organization, etc.)
 */
export const fetchMainCategoryFormSkeleton = async (mainCategoryName, formType = 'registration') => {
  try {
    console.log('Fetching categories for main category:', mainCategoryName);
    const response = await getCategories();
    
    let categories = [];
    if (Array.isArray(response)) {
      categories = response;
    } else if (response.data && Array.isArray(response.data)) {
      categories = response.data;
    }

    console.log('Categories fetched:', categories.length);
    const mainCategory = categories.find(cat => cat.name === mainCategoryName);
    
    if (!mainCategory) {
      console.error('Main category not found:', mainCategoryName);
      throw new Error('Main category not found');
    }

    console.log('Main category found:', mainCategory.name);
    console.log('Form skeleton:', mainCategory.registrationFromSkeleton ? 'Found' : 'Not found');

    // Return the appropriate form skeleton
    if (formType === 'registration') {
      return mainCategory.registrationFromSkeleton || null;
    } else if (formType === 'edit') {
      return mainCategory.editFormSkeleton || null;
    } else if (formType === 'correction') {
      return mainCategory.correctionFormSkeleton || null;
    }

    return null;
  } catch (error) {
    console.error('Error fetching main category form skeleton:', error);
    throw error;
  }
};
